var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-text',[_c('v-row',{staticClass:"d-flex align-center justify-end px-4"},[_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){_vm.parkingFineReportingTaskDialog = true}}},[_c('v-icon',[_vm._v("mdi-plus")]),_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.ADD_NEW'))+" ")],1)],1),_c('v-data-table',{attrs:{"headers":[
          {
            text: 'ID',
            align: 'start',
            sortable: false,
            value: 'ID'
          },
          {
            text: _vm.$vuetify.lang.t('$vuetify.VEHICLE_GROUPS.GROUP_NAME'),
            align: 'start',
            sortable: false,
            value: 'vehicleGroupName'
          },
          {
            text: _vm.$vuetify.lang.t(
              '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.EMAIL_TO'
            ),
            align: 'start',
            sortable: false,
            value: 'emailTo'
          },
          {
            text: _vm.$vuetify.lang.t(
              '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.EMAIL_BCC'
            ),
            align: 'start',
            sortable: false,
            value: 'emailBcc'
          },
          {
            text: _vm.$vuetify.lang.t(
              '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.SENDING_DAYS'
            ),
            align: 'start',
            sortable: false,
            value: 'monthlyReportSendingDays'
          },
          {
            text: _vm.$vuetify.lang.t(
              '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.IS_MONTHLY_REPORTING_ENABLED'
            ),
            align: 'start',
            sortable: false,
            value: 'isMonthlyReportingEnabled'
          },
          {
            text: '',
            align: 'end',
            sortable: false,
            value: 'actions'
          }
        ],"items":_vm.parkingFineReportingTasks,"hide-default-footer":"","items-per-page":-1},scopedSlots:_vm._u([{key:"item.emailTo",fn:function(props){return [_c('td',[_c('div',{staticClass:"text-truncate",staticStyle:{"max-width":"248px"}},[_vm._v(" "+_vm._s(props.item.emailTo)+" ")])])]}},{key:"item.emailBcc",fn:function(props){return [_c('td',[_c('div',{staticClass:"text-truncate",staticStyle:{"max-width":"248px"}},[_vm._v(" "+_vm._s(props.item.emailBcc ? props.item.emailBcc : '-')+" ")])])]}},{key:"item.isMonthlyReportingEnabled",fn:function(props){return [_c('td',[_c('v-icon',{attrs:{"small":"","color":props.item.isMonthlyReportingEnabled ? 'success' : 'orange'}},[_vm._v(" "+_vm._s(props.item.isMonthlyReportingEnabled ? _vm.$vuetify.lang.t('$vuetify.YES') : _vm.$vuetify.lang.t('$vuetify.NO'))+" ")])],1)]}},{key:"item.actions",fn:function(props){return [_c('td',{staticClass:"d-flex align-center justify-end"},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){return _vm.openEditParkingFineReportingTaskDialog(props.item)}}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pencil")])],1)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.EDIT'))+" ")])]),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){return _vm.onOpenLicensePlateListClick(props.item)}}},on),[_c('v-icon',{attrs:{"small":"","color":"blue"}},[_vm._v("mdi-car")])],1)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t( '$vuetify.ENFORCEMENT.PARKING_FINE_REPORTS.VEHICLE_LIST' ))+" ")])]),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":function($event){return _vm.onParkingFineReportingTaskDelete(props.item)}}},on),[_c('v-icon',{attrs:{"small":"","color":"error"}},[_vm._v("mdi-delete")])],1)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.$vuetify.lang.t('$vuetify.DELETE'))+" ")])])],1)]}}])})],1)],1),(_vm.parkingFineReportingTaskDialog)?_c('ParkingFineReportingTaskDialog',{attrs:{"visible":_vm.parkingFineReportingTaskDialog},on:{"close":function($event){_vm.parkingFineReportingTaskDialog = false}}}):_vm._e(),(_vm.vehicleGroupLicensePlatesDialog)?_c('VehicleGroupLicensePlatesDialog',{attrs:{"visible":_vm.vehicleGroupLicensePlatesDialog},on:{"close":function($event){_vm.vehicleGroupLicensePlatesDialog = false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }